module.exports = __webpack_public_path__ + "img/question_title.89168b47.png";